import React, { useEffect, useState } from 'react';
import { EventTypeInput } from '../../../types/ViewModel/EventTypeInput';
import { CheckBoxInputWrapper } from './CheckBoxInput.styles';
import EventTypeInputFactory from '../../../factory/EventTypeInputFactory';
import { InputWrapper, InputHeadingWrapper, InputFieldWrapper } from '../EventInput.styles';
import { resolveHeading } from '../../../utils/event/headingOverrides';
import { Checkbox } from 'antd';
import type { CheckboxChangeEvent } from 'antd/es/checkbox';

type Props = {
    onChange: (isCompleted: boolean, key: number, isEmpty: boolean, isValid: boolean) => void;
    evTypeInput: EventTypeInput;
    key: string;
};

const CheckBoxInputComponent: React.FC<Props> = (props) => {
    const [eventTypeInput, setEventTypeInput] = useState<EventTypeInput | null>(null);
    const { createEventTypeInput } = EventTypeInputFactory();

    useEffect(() => {
        const evTypeInp = createEventTypeInput(props.evTypeInput);

        setEventTypeInput(evTypeInp);
    }, [props.evTypeInput]);

    const isCheckboxInputValid = (evTypeInput: EventTypeInput): boolean => {
        if (evTypeInput && evTypeInput.eventTypeInputReg && evTypeInput.inputMandatory) {
            return evTypeInput.eventTypeInputReg.checkboxValueReg;
        }
        return false;
    };

    const getValue = (): boolean => {
        if (eventTypeInput && eventTypeInput.eventTypeInputReg) {
            return eventTypeInput.eventTypeInputReg.checkboxValueReg;
        }
        return false;
    };

    const onChange = (e: CheckboxChangeEvent) => {
        const _isChecked = e.target.checked;
        props.onChange(_isChecked, props.evTypeInput.eventTypeInputId, !_isChecked, true);
    };

    return (
        <>
            {eventTypeInput && (
                <InputWrapper>
                    <InputHeadingWrapper>{resolveHeading(eventTypeInput)}</InputHeadingWrapper>
                    <InputFieldWrapper>
                        <CheckBoxInputWrapper isNotValid={!isCheckboxInputValid(props.evTypeInput)}>
                            <Checkbox checked={getValue()} onChange={onChange}>
                                Yes
                            </Checkbox>
                        </CheckBoxInputWrapper>
                    </InputFieldWrapper>
                </InputWrapper>
            )}
        </>
    );
};

export default CheckBoxInputComponent;
